

type Props = {
    dir: string;
    componentId: string;
    show: boolean;
}

const CarouselNavigationButtons: React.FC<Props> = ({dir, componentId, show }) => {

    if (!show) return null;

    return <>
        <span className={
            `swiper-button-prev btn-right 
            btn-${dir === "rtl" ? "left" : "right"}-${componentId}`}>
        </span>
        <span className={
            `swiper-button-next btn-left 
            btn-${dir === "rtl" ? "right" : "left"}-${componentId}`}>
        </span>
    </>
}

export default CarouselNavigationButtons;